export const en = {
  Globals: {
    dashboard: "Dashboard",
  },
};
